import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';

import {School, Year, Grade, Class, Subject, SchoolCategory, Country, Region, User, Role} from '../model/userUsage.model';

import { environment } from '../../environments/environment';

@Injectable()
export class userUsageService {
  headers: any;
  options: any;
  startDate = '2019-08-20';
  endDate = '2019-08-22';
  selectedTimePeriod: any;
  sub: any;
  filterDate: any;
  constructor( private http: HttpClient, private _route:ActivatedRoute) {
      this.headers = new Headers();
      this.headers.append('Authorization', 'CTL '+ localStorage.getItem('token'));
      this.headers.append('Content-Type', 'application/json');
  }
  getSelectedTimePeriod(date:any, project_id:any, country_id:any): Observable<any[]> {
    this.startDate = date.startdate;
    this.endDate = date.enddate;
    this.options = {headers: this.headers};
    return this.http.get(
      environment.dashAPI + 'users?startDate='+date.startdate + 'T00:00:00.000Z&endDate='+date.enddate+'T23:23:20.201Z' , this.options)
        .pipe(map((response: any) => response));

  }

  userUsagedetail(startdate:any, enddate:any): Observable<any[]> {
    console.log("userusageDetail>>>>>")
    this.options = {headers: this.headers};
    return this.http.get(
      environment.dashAPI+'/users?startDate='+startdate+'T00:00:00.000Z&endDate='+enddate+'T23:23:20.201Z', this.options)
    .pipe(map((response: any) => response ));

  }

  devicesUsagedetail(): Observable<any[]> {
    this.options = {headers: this.headers};
    return this.http.get(environment.dashAPI + '/devices?startDate=' + this.startDate + 'T00:00:00.000Z&endDate='+this.endDate+'T23:23:20.201Z&filter_by=project_id,country_id&filter_value=5d6ba67ae8f3dc2210fb6c54,596b2da69388ea9aa9a10145' , this.options)
    .pipe(map((response: any) => response));
  }

  applicationUsagedetail(): Observable<any[]> {
    this.options = {headers: this.headers};
    return this.http.get(environment.dashAPI + '/application?startDate=' + this.startDate + 'T00:00:00.000Z&endDate='+this.endDate+'T23:23:20.201Z&filter_by=project_id,country_id&filter_value=5d6ba67ae8f3dc2210fb6c54,596b2da69388ea9aa9a10145' , this.options)
    .pipe(map((response: any) => response));
  }

  contentUsagedetail(): Observable<any[]> {
    this.options = {headers: this.headers};
    return this.http.get(environment.dashAPI + '/content?startDate=' + this.startDate + 'T00:00:00.000Z&endDate='+this.endDate+'T23:23:20.201Z&filter_by=project_id,country_id&filter_value=5d6ba67ae8f3dc2210fb6c54,596b2da69388ea9aa9a10145' , this.options)
    .pipe(map((response: any) => response));
  }

  inventoryReport(): Observable<any[]> {
    this.options = {headers: this.headers};
    return this.http.get(environment.dashAPI + '/inventory?startDate=' + this.startDate + 'T00:00:00.000Z&endDate='+this.endDate+'T23:23:20.201Z&filter_by=project_id,country_id&filter_value=5d6ba67ae8f3dc2210fb6c54,596b2da69388ea9aa9a10145' , this.options)
    .pipe(map((response: any) => response));
  }

  appinventoryReport(): Observable<any[]> {
    this.options = {headers: this.headers};
    return this.http.get(environment.dashAPI + '/appinventory?startDate=' + this.startDate + 'T00:00:00.000Z&endDate='+this.endDate+'T23:23:20.201Z&filter_by=project_id,country_id&filter_value=5d6ba67ae8f3dc2210fb6c54,596b2da69388ea9aa9a10145' , this.options)
    .pipe(map((response: any) => response));
  }

  downloadUserList(): Observable<Blob> {
    // add header
    let URLSearchParams = new HttpParams();
    URLSearchParams = URLSearchParams.set('action', 'download');

    this.options = { headers: this.headers, responseType: Blob, params: URLSearchParams };
    return this.http.get(environment.dashAPI + '/content?startDate=2019-08-20T00:00:00.000Z&endDate=2019-08-22T23:23:20.201Z&filter_by=project_id,country_id&filter_value=5d6ba67ae8f3dc2210fb6c54,596b2da69388ea9aa9a10145&action=download', this.options)
       .pipe(map((response: any) => response.blob() ));
  }


  listCountry(): Observable<Country[]> {
    this.options = {headers: this.headers};
    return this.http.get(environment.dashAPI + 'countries', this.options)
      .pipe(map((response: any) => response ));
  }

  listProjects(): Observable<any[]> {
    this.options = {headers: this.headers};
    return this.http.get(environment.dashAPI + 'projects', this.options)
      .pipe(map((response: any) => response));
  }

  listSchools(project_id:any): Observable<any[]> {
    this.options = {headers: this.headers};
    return this.http.get(environment.dashAPI + 'schools/project/' + project_id, this.options)
      .pipe(map((response: any) => response ));
  }
  listGenders(): Observable<any[]> {
    this.options = {headers: this.headers};
    return this.http.get(environment.dashAPI + 'gender', this.options)
      .pipe(map((response: any) => response ));
  }
}
